import { capitalize } from 'utilities';

import { theme } from '../shared/styling';

export const COLORING_GRID_STATUSES = {
  new: 'new',
  pending: 'pending',
  edited: 'edited',
  approved: 'approved',
  rejected: 'rejected',
  disabled: 'disabled',
  deleted: 'deleted',
} as const;

export const COLORING_GRID_STATUS_OPTIONS = [
  { value: COLORING_GRID_STATUSES.new, label: capitalize(COLORING_GRID_STATUSES.new) },
  { value: COLORING_GRID_STATUSES.pending, label: capitalize(COLORING_GRID_STATUSES.pending) },
  { value: COLORING_GRID_STATUSES.edited, label: capitalize(COLORING_GRID_STATUSES.edited) },
  { value: COLORING_GRID_STATUSES.approved, label: capitalize(COLORING_GRID_STATUSES.approved) },
  { value: COLORING_GRID_STATUSES.rejected, label: capitalize(COLORING_GRID_STATUSES.rejected) },
  { value: COLORING_GRID_STATUSES.disabled, label: capitalize(COLORING_GRID_STATUSES.disabled) },
  { value: COLORING_GRID_STATUSES.deleted, label: capitalize(COLORING_GRID_STATUSES.deleted) },
];

export const ColoringGridStatusConstants = {
  new: {
    color: theme.colors.info,
    label: 'New',
    value: 'new',
  },
  approved: {
    color: 'linear-gradient(180deg,#00c056 0%,#00bb54 13.02%,#009a45 100%)',
    label: 'Approved',
    value: 'approved',
  },
  rejected: {
    color: 'red',
    label: 'Rejected',
    value: 'rejected',
  },
  deleted: {
    color: 'red',
    label: 'Deleted',
    value: 'deleted',
  },
  pending: {
    color: theme.colors.inProgress,
    label: 'Pending',
    value: 'pending',
  },
  edited: {
    color: theme.colors.inProgress,
    label: 'Edited',
    value: 'edited',
  },
  disabled: {
    color: 'gray',
    label: 'Disabled',
    value: 'disabled',
  },
} as const;

export const COLORING_GRID_PRICE_LIST = [
  {
    value: 0,
    label: 'Free',
  },
  {
    value: 1,
    label: 'Premium',
  },
];
